import { ViewerTemplate } from '../ViewerTemplate';
import React from 'react';
import { FlatEndorsementsViewer } from './FlatEndorsementsViewer';
import { IEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IEndorsementConfig';
import { Grid } from 'ui-toolkit';
import { LoanCalcEndorsementsViewer } from './LoanCalcEndorsementsViewer';
import { PolicyCalcEndorsementsViewer } from './PolicyCalcEndorsementViewer';

export const EndorsementsViewer: React.FC<{ endorsementConfig: IEndorsementConfigData }> = ({ endorsementConfig }) => (
  <ViewerTemplate viewerName={'Endorsements:'}>
    <Grid>
      <FlatEndorsementsViewer flatEndorsements={endorsementConfig.flatEndorsements} />
      <LoanCalcEndorsementsViewer loanCalcEndorsements={endorsementConfig.loanCalcEndorsements} />
      <PolicyCalcEndorsementsViewer policyCalcEndorsements={endorsementConfig.policyCalcEndorsements} />
    </Grid>
  </ViewerTemplate>
);
